import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import SummerThemeWrapper from "../Home/SummerThemeWrapper";
import RSVPForm from "./RSVPForm registartion closed";
// import RSVPForm from "./RSVPForm";
import RightLeafSVG from "./RightLeafSVG";
import LeftLeafSVG from "./LeftLeafSVG";

const SummerMeet = () => {
  const location = useLocation();
  const videoRef = useRef(null);
  const [videoInView, setVideoInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVideoInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (location.hash === "#rsvp-form") {
      // Retry a few times in case images/layout take a moment to paint
      const attemptScroll = (attemptsLeft) => {
        const formElement = document.getElementById("rsvp-form");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth" });
        } else if (attemptsLeft > 0) {
          setTimeout(() => attemptScroll(attemptsLeft - 1), 300);
        }
      };

      // Start the scroll attempt sequence natively using CSS scroll-margin-top
      setTimeout(() => attemptScroll(3), 100);
    } else if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.hash]);

  // Variants for animation
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 120,
      },
    }),
  };

  // Add `\n` where you want a line break
  const headingText = "Strengthening Connections Across the\nMSB Community";

  const title = "Summer Members Meet 2026";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <SummerThemeWrapper hideCountdown={true} hideHeroParticles={true}>
      <div>
        <Helmet>
          <title>Summer Members Meet 2026 | MSB Association UK</title>
          <meta
            name="description"
            content="Join the MSB Association Summer Members Meet on 26 June 2026 at 1864 Rooftop Bar & Kitchen, London. Network, connect, and strengthen the MSB community."
          />
          <link rel="canonical" href="https://msbassociationuk.org/summer-meet-2026" />

          <meta property="og:title" content="Summer Members Meet 2026 | MSB Association UK" />
          <meta
            property="og:description"
            content="Join the MSB Association Summer Members Meet on 26 June 2026 at 1864 Rooftop Bar & Kitchen, London. Network, connect, and strengthen the MSB community."
          />
          <meta property="og:url" content="https://msbassociationuk.org/summer-meet-2026" />
          <meta property="og:image" content="https://msbassociationuk.org/MSB-summer-members-meet.png" />
          <meta property="og:type" content="website" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Summer Members Meet 2026 | MSB Association UK" />
          <meta
            name="twitter:description"
            content="Join the MSB Association Summer Members Meet on 26 June 2026 at 1864 Rooftop Bar & Kitchen, London. Network, connect, and strengthen the MSB community."
          />
          <meta name="twitter:image" content="https://msbassociationuk.org/MSB-summer-members-meet.png" />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Event",
              "name": "Summer Members Meet 2026",
              "startDate": "2026-06-26T18:00:00+01:00",
              "endDate": "2026-06-26T21:00:00+01:00",
              "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
              "eventStatus": "https://schema.org/EventScheduled",
              "location": {
                "@type": "Place",
                "name": "1864 Rooftop Bar & Kitchen",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "London",
                  "addressCountry": "GB"
                }
              },
              "organizer": {
                "@type": "Organization",
                "name": "MSB Association UK",
                "url": "https://msbassociationuk.org"
              },
              "description": "Join the MSB Association Summer Members Meet on 26 June 2026 at 1864 Rooftop Bar & Kitchen, London. Network, connect, and strengthen the MSB community.",
              "image": "https://msbassociationuk.org/MSB-summer-members-meet.png"
            })}
          </script>
        </Helmet>
        {/* Inline full-width banner — adapted from HeroSection-summer-meet-ban-date-reveal */}
          <style>
            {`
              @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500;600;700&display=swap');

              .sm-banner-section {
                padding: 110px 0 0;
                font-family: 'Inter', sans-serif;
              }

              .sm-banner-wrap {
                background: linear-gradient(135deg, #FFF8ED 0%, #FFF3D6 50%, #FFF0E0 100%);
                border-top: 1.5px solid #FACF7A;
                border-bottom: 1.5px solid #FACF7A;
                overflow: hidden;
                position: relative;
                min-height: 260px;
                width: 100%;
              }

              .sm-banner-container {
                max-width: 1100px;
                margin: 0 auto;
                position: relative;
              }

              .sm-deco-circle {
                position: absolute;
                border-radius: 50%;
                opacity: 0.18;
              }

              .sm-inner {
                display: flex;
                align-items: stretch;
                gap: 0;
                position: relative;
                z-index: 2;
              }

              .sm-left-panel {
                flex: 0 0 52%;
                padding: 48px 36px 40px 40px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                border-right: 1px dashed #F5C870;
              }

              .sm-title-row {
                display: flex;
                align-items: baseline;
                gap: 10px;
                flex-wrap: wrap;
              }

              .sm-word-summer {
                font-family: 'Playfair Display', Georgia, serif;
                font-size: 42px;
                font-weight: 700;
                color: #E8851A;
                line-height: 1;
              }

              .sm-word-members, .sm-word-meet, .sm-word-year {
                font-size: 32px;
                font-weight: 700;
                color: #1A1A1A;
                line-height: 1;
              }

              .sm-word-year { color: #E8851A; }

              .sm-tagline {
                font-size: 13px;
                color: #7A5E30;
                font-weight: 400;
                letter-spacing: 0.3px;
                margin-top: 2px;
              }

              .sm-sponsor-pill {
                display: inline-flex;
                flex-direction: column;
                align-items: center;
                gap: 5px;
                background: #fff;
                border: 1.5px solid #F0C060;
                border-radius: 16px;
                padding: 10px 18px 8px;
                margin-top: 8px;
                width: fit-content;
              }

              .sm-sponsor-logo { height: 20px; width: auto; }

              .sm-sponsor-label {
                font-size: 9px;
                font-weight: 600;
                color: #B87A10;
                letter-spacing: 1.5px;
                text-transform: uppercase;
              }

              .sm-right-panel {
                flex: 1;
                padding: 40px 36px 40px 36px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 14px;
              }

              .sm-detail-row {
                display: flex;
                align-items: flex-start;
                gap: 10px;
              }

              .sm-detail-icon {
                width: 30px; height: 30px;
                background: #E8851A;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                margin-top: 1px;
              }

              .sm-detail-text-main {
                font-size: 15px;
                font-weight: 600;
                color: #1A1A1A;
                line-height: 1.3;
              }

              .sm-detail-text-sub {
                font-size: 12px;
                color: #7A5E30;
                line-height: 1.4;
                margin-top: 2px;
              }

              .sm-divider {
                height: 1px;
                background: repeating-linear-gradient(90deg, #F5C870 0px, #F5C870 6px, transparent 6px, transparent 12px);
                margin: 2px 0;
              }

              .sm-btn-row {
                display: flex;
                gap: 10px;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 4px;
              }

              .sm-btn-outline {
                padding: 10px 22px;
                border-radius: 100px;
                border: 2px solid #E8851A;
                background: transparent;
                color: #E8851A;
                font-size: 13px;
                font-weight: 700;
                cursor: pointer;
                letter-spacing: 0.3px;
                transition: all 0.22s ease;
                font-family: 'Inter', sans-serif;
                text-decoration: none;
                display: inline-flex;
                align-items: center;
                justify-content: center;
              }

              .sm-btn-outline:hover {
                background: #E8851A;
                color: #fff;
                transform: translateY(-1px);
              }

              .sm-btn-fill {
                padding: 10px 22px;
                border-radius: 100px;
                border: none;
                background: #E8851A;
                color: #fff;
                font-size: 13px;
                font-weight: 700;
                cursor: pointer;
                letter-spacing: 0.3px;
                transition: all 0.22s ease;
                font-family: 'Inter', sans-serif;
                box-shadow: 0 4px 16px rgba(232,133,26,0.30);
                text-decoration: none;
                display: inline-flex;
                align-items: center;
                justify-content: center;
              }

              .sm-btn-fill:hover {
                background: #C56B0A;
                transform: translateY(-1px);
                box-shadow: 0 6px 20px rgba(232,133,26,0.40);
              }

              .sm-deco-lemon, .sm-deco-leaf, .sm-deco-sun-ring {
                position: absolute;
                pointer-events: none;
                z-index: 1;
              }

              @keyframes sm-float1 { 0%,100%{transform:translateY(0) rotate(-10deg)} 50%{transform:translateY(-6px) rotate(-8deg)} }
              @keyframes sm-float2 { 0%,100%{transform:translateY(0) rotate(15deg)} 50%{transform:translateY(-8px) rotate(17deg)} }
              @keyframes sm-pulse-ring { 0%,100%{opacity:0.12} 50%{opacity:0.22} }

              .sm-anim-float1 { animation: sm-float1 3.8s ease-in-out infinite; }
              .sm-anim-float2 { animation: sm-float2 4.5s ease-in-out infinite; }
              .sm-anim-pulse { animation: sm-pulse-ring 3s ease-in-out infinite; }

              @media (max-width: 768px) {
                .sm-banner-section { padding: 80px 0 0; }
                .sm-inner { flex-direction: column; }
                .sm-left-panel {
                  flex: 0 0 auto;
                  border-right: none;
                  border-bottom: 1px dashed #F5C870;
                }
                .sm-word-summer { font-size: 32px; }
                .sm-word-members, .sm-word-meet, .sm-word-year { font-size: 24px; }
              }
            `}
          </style>

          <div className="sm-banner-section">
            <div className="sm-banner-wrap">
              <div className="sm-deco-circle sm-anim-pulse" style={{ width: "220px", height: "220px", background: "#F5A623", top: "-70px", right: "30px" }}></div>
              <div className="sm-deco-circle" style={{ width: "130px", height: "130px", background: "#FBA834", bottom: "-40px", left: "20px" }}></div>
              <div className="sm-deco-circle" style={{ width: "80px", height: "80px", background: "#FFD580", top: "20px", left: "180px", opacity: "0.25" }}></div>

              <div className="sm-deco-lemon sm-anim-float2" style={{ top: "12px", right: "16px", opacity: "0.55" }}>
                <svg width="54" height="54" viewBox="0 0 54 54" fill="none"><circle cx="27" cy="27" r="25" fill="#FFE066" stroke="#E8C020" strokeWidth="1.5"/><circle cx="27" cy="27" r="18" fill="#FFF4A0" stroke="#E8C020" strokeWidth="0.8"/><line x1="27" y1="9" x2="27" y2="45" stroke="#D4A800" strokeWidth="0.8" opacity="0.6"/><line x1="9" y1="27" x2="45" y2="27" stroke="#D4A800" strokeWidth="0.8" opacity="0.6"/><line x1="14" y1="14" x2="40" y2="40" stroke="#D4A800" strokeWidth="0.8" opacity="0.6"/><line x1="40" y1="14" x2="14" y2="40" stroke="#D4A800" strokeWidth="0.8" opacity="0.6"/></svg>
              </div>

              <div className="sm-deco-leaf sm-anim-float1" style={{ bottom: "22px", right: "22px", opacity: "0.45" }}>
                <svg width="36" height="48" viewBox="0 0 36 48" fill="none"><path d="M18 46 C18 46 2 34 2 18 C2 8 10 2 18 2 C26 2 34 8 34 18 C34 34 18 46 18 46Z" fill="#5DB87A" stroke="#3D8A5A" strokeWidth="1"/><line x1="18" y1="4" x2="18" y2="46" stroke="#3D8A5A" strokeWidth="1" opacity="0.5"/><line x1="10" y1="12" x2="26" y2="24" stroke="#3D8A5A" strokeWidth="0.7" opacity="0.4"/><line x1="8" y1="22" x2="28" y2="32" stroke="#3D8A5A" strokeWidth="0.7" opacity="0.4"/></svg>
              </div>

              <div className="sm-deco-sun-ring sm-anim-pulse" style={{ top: "-18px", left: "-18px", opacity: "0.18" }}>
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none"><circle cx="45" cy="45" r="38" stroke="#FBA834" strokeWidth="3" strokeDasharray="8 5"/></svg>
              </div>

              <div style={{ position: "absolute", bottom: "0", right: "110px", zIndex: "1", opacity: "0.3" }}>
                <svg width="12" height="70" viewBox="0 0 12 70" fill="none"><rect x="1" y="0" width="10" height="70" rx="5" fill="#E8851A"/><rect x="3" y="0" width="3" height="70" rx="2" fill="#fff" opacity="0.4"/></svg>
              </div>

              <div className="sm-banner-container">
                <div className="sm-inner">
                  <div className="sm-left-panel">
                    <div>
                      <div className="sm-title-row"><span className="sm-word-summer">Summer</span></div>
                      <div className="sm-title-row" style={{ marginTop: "2px" }}>
                        <span className="sm-word-members">Members</span>
                        <span className="sm-word-meet">Meet</span>
                        <span className="sm-word-year">2026</span>
                      </div>
                    </div>
                    <div className="sm-tagline">Make your voice count</div>
                    <div className="sm-sponsor-pill">
                      <img src="assets/images/peratera-logo-black.svg" alt="Peratera" className="sm-sponsor-logo" />
                      <span className="sm-sponsor-label">Event sponsor</span>
                    </div>
                  </div>

                  <div className="sm-right-panel">
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                      <div className="sm-detail-row">
                        <div className="sm-detail-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                        </div>
                        <div>
                          <div className="sm-detail-text-main">Friday, 26<sup style={{ fontSize: "10px" }}>th</sup> June 2026</div>
                          <div className="sm-detail-text-sub">06:00 PM BST</div>
                        </div>
                      </div>
                      <div className="sm-divider"></div>
                      <div className="sm-detail-row">
                        <div className="sm-detail-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
                        </div>
                        <div>
                          <div className="sm-detail-text-main">1864 Rooftop Bar &amp; Kitchen</div>
                          <div className="sm-detail-text-sub">6th Floor, John Lewis, 300 Oxford Street<br/>London WC1 1DX <br/> <strong> Private entrance - </strong> 4 Old Cavendish St, London W1G 0NE</div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="sm-btn-row">
                      <a className="sm-btn-fill" href="#rsvp-form" onClick={(e) => { e.preventDefault(); document.getElementById("rsvp-form")?.scrollIntoView({ behavior: "smooth" }); }}>Register Now ✦</a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

        <main className="page_content">
          {/* Page Header - Start
  ================================================== */}
          {/* <section className="page_header text-center section_decoration overflow-hidden bg-image-css">
            <div className="container">
              <motion.h1
                className="page_title text-white"
                initial="hidden"
                animate="visible"
                style={{
                  display: "flex",
                  flexDirection: "column", // stack lines vertically
                  alignItems: "center",
                  textAlign: "center",
                  flexWrap: "wrap",
                }}
              >
                {title
                  .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                  .split("\n")
                  .map((line, lineIndex) => (
                    <div
                      key={`line-${lineIndex}`}
                      style={{
                        display: "flex",
                        flexWrap: "wrap", // ensure words wrap on smaller screens
                        justifyContent: "center",
                        gap: "0.4rem"
                      }}
                    >
                      {line.split(" ").map((word, wordIndex) => (
                        <span
                          key={`word-${lineIndex}-${wordIndex}`}
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {word.split("").map((letter, charIndex) => {
                            const uniqueIndex = lineIndex * 50 + wordIndex * 15 + charIndex;
                            return (
                              <motion.span
                                key={`char-${lineIndex}-${wordIndex}-${charIndex}`}
                                custom={uniqueIndex}
                                initial="hidden"
                                animate="visible"
                                variants={letterVariants}
                                style={{
                                  display: "inline-block",
                                }}
                              >
                                {letter}
                              </motion.span>
                            );
                          })}
                        </span>
                      ))}
                    </div>
                  ))}
              </motion.h1>

              <div className="d-flex justify-content-center align-items-center mb-4 mt-2 flex-wrap" style={{ color: "#fff" }}>
                <span className="me-2" style={{ fontSize: "18px" }}>Sponsored by</span>
                <a href="https://peratera.com/" target="_blank" rel="noreferrer">
                  <img
                    // src="/assets/images/clear-junction-logo.svg" 
                    // src="https://peratera.com/icons/logo.svg" 
                    src="/assets/images/peratera-logo.svg"
                    alt="Peratera Logo"
                    className="img-fluid"
                    style={{ height: "40px", objectFit: "contain", maxWidth: "200px" }}
                  />
                </a>
              </div>

              <ul className="breadcrumb_nav unordered_list justify-content-center">
                <li>
                  <span
                    style={{
                      fontSize: "22px",
                      fontWeight: "600",
                      lineHeight: "25px",
                      color: "#FBA834",
                    }}
                  >
                    Friday, 26 June 2026 | 6:00 PM BST Onwards
                    <br />
                    <br />
                    📍 1864 Rooftop Bar &amp; Kitchen <br />
                    6th Floor,
                    John Lewis,
                    300 Oxford Street,
                    London WC1 1DX
                    <br />
                    <p style={{ fontSize: "16px", fontWeight: "400" }}>
                      Private entrance - 4 Old Cavendish St, London W1G 0NE
                    </p>
                  </span>
                </li>
              </ul>
            </div>
          </section> */}
          {/* Page Header - End
  ================================================== */}
          {/* Contact Section - Start
  ================================================== */}
          <section className="contact_section section_space bg-dark" style={{ position: "relative", overflow: "hidden" }}>
            <LeftLeafSVG />
            <RightLeafSVG />
            <div className="container">
              <div className="item_details_content">
                <h2 className="item_details_heading text-center">
                  {headingText.split("").map((char, i) => {
                    if (char === "\n") {
                      return <br key={`br-${i}`} />;
                    }
                    return (
                      <motion.span
                        key={`${char}-${i}`}
                        custom={i}
                        initial="hidden"
                        animate="visible"
                        variants={headingVariants}
                      >
                        {char}
                      </motion.span>
                    );
                  })}
                </h2>
                <p>
                  The MSB Association is excited to invite you to the <strong>Summer Members Meet 2026</strong>, sponsored by <strong>Peratera</strong>, taking place on <strong>Friday, 26th June 2026</strong>, at <strong> 1864 Rooftop Bar & Restaurant,</strong> 6th Floor, John Lewis, 300 Oxford Street, London WC1 1DX. <br/> <strong>Private entrance - </strong> 4 Old Cavendish St, London W1G 0NE. 
                </p>
                

                <p>
                  Following the tremendous success of the <strong>Annual Members Meet 2026</strong>, this summer gathering aims to continue building stronger industry relationships, encouraging collaboration, and creating valuable networking opportunities within the MSB sector.
                </p>

                <p>
                  Join us for an engaging evening of industry dialogue, shared insights, and high-value networking with professionals shaping the future of the regulated payments and remittance industry.
                </p>

                <div ref={videoRef} style={{ position: "relative", width: "100%", aspectRatio: "16 / 9", maxHeight: "550px", marginBottom: "1rem", background: "#000" }}>
                  {videoInView && (
                    <iframe style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }} src="https://www.youtube.com/embed/OuJG6FpCnbQ?si=BQ1qfFV1kKaZxelo" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  )}
                </div>

                <h5 className="mb-3">About Peratera</h5>
                <p>
                  We are proud to have <strong>Peratera</strong> as our sponsor for the Summer Members Meet 2026. As a modern payment platform supporting global businesses with secure cross-border payment solutions, Peratera shares our commitment to innovation, compliance excellence, and industry growth. Their partnership reflects a shared vision of strengthening collaboration and supporting the evolving needs of the MSB ecosystem.
                </p>

                <h5 className="mb-3">Why Attend?</h5>
                <ul className="mb-4">
                  <li className="mb-2">Network with MSB business owners, compliance professionals, and industry leaders</li>
                  <li className="mb-2">Build valuable relationships across the MSB and fintech ecosystem</li>
                  <li className="mb-2">Exchange insights on current market trends and regulatory developments</li>
                  <li className="mb-2">Explore collaboration and partnership opportunities</li>
                  <li className="mb-2">Be part of meaningful discussions shaping the future of the MSB sector</li>
                </ul>

                <p className="mb-4">
                  This event is designed to encourage informed conversation, stronger industry engagement, and practical networking opportunities for regulated businesses across the sector.
                </p>

                <h5 className="mb-3">A Community That Continues to Grow</h5>
                <p className="mb-2">
                  As many of you know, the MSB Association Annual Members Meet 2026 was a tremendous success, bringing together industry leaders, partners, and members for an unforgettable evening of collaboration and networking.
                </p>
                <p className="mb-2">
                  If you missed that event, this is your opportunity to experience the energy, connections, and conversations that make the MSB Association community truly unique.
                </p>
                {/* <p className="mb-4">
                  We look forward to welcoming you.
                </p> */}

                {/* <h5 className="mb-3">Special Guest:</h5>
                <p>
                  We are pleased to share that <strong>representatives from the FCA and HMRC</strong> have been invited to join us for this special evening. Their participation, subject to confirmation, will offer members a valuable opportunity to engage directly with key regulators, gain insight into current supervisory priorities, and better understand evolving compliance expectations.
                </p> */}

                <h5 className="mb-3 mt-4">Member Participation & Subscription</h5>
                <p className="mb-2">
                  As a not-for-profit association, the MSB Association depends on the active support of its members to deliver impactful events, advocacy, and industry representation.
                </p>
                <p className="mb-2">
                  We kindly request all members to ensure their <strong>annual subscription fee is settled prior to attending</strong>. These contributions help us:
                </p>
                <ul className="mb-4">
                  <li>Cover venue and event costs</li>
                  <li>Support regulatory engagement</li>
                  <li>Deliver member services and initiatives</li>
                  <li>Strengthen the collective influence of the MSB sector</li>
                </ul>
                <p className="mb-4">
                  Your support ensures the continued growth and credibility of our community.
                </p>

                <h5 className="mb-3 mt-4">RSVP</h5>
                <p className="mb-2">
                  Attendance is limited and early confirmation is strongly encouraged.
                </p>
                <p className="mb-2">
                  Please complete the registration form below to secure your place at the MSB Association Summer Members Meet 2026.
                </p>
                <p>
                  <strong>We look forward to welcoming you.</strong>
                </p>

                <div className="row mb-4 mt-4 align-item-center">
                  <div className="col-lg-6 col-md-6 col-12">
                    <h5 className="mb-3">Event Program</h5>
                    <div className="schedule-date">
                      Friday, 26 June 2026
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item">
                        <div>
                          <h6 className="fw-bold mb-1">
                            Welcome Drinks & Registration
                          </h6>
                        </div>
                        <div style={{ whiteSpace: "nowrap" }}>6:00 PM – 6:30 PM</div>
                      </div>
                      <div className="schedule-item">
                        <div>
                          <h6 className="fw-bold mb-1">Welcome Address by the MSB Association Board</h6>
                        </div>
                        <div style={{ whiteSpace: "nowrap" }}>6:30 PM – 6:45 PM</div>
                      </div>
                      <div className="schedule-item">
                        <div>
                          <h6 className="fw-bold mb-1">
                            Welcome note from Peratera CEO - Mr. Dimitri Savtchenko
                          </h6>
                        </div>
                        <div style={{ whiteSpace: "nowrap" }}>6:50 PM – 7:00 PM</div>
                      </div>
                      <div className="schedule-item">
                        <div>
                          <h6 className="fw-bold mb-1">
                            Key note Speaker - Mr. Naveed Akhter (Head of Compliance Peratera)
                          </h6>
                        </div>
                        <div style={{ whiteSpace: "nowrap" }}>7:05 PM – 7:20 PM</div>
                      </div>
                      <div className="schedule-item">
                        <div>
                          <h6 className="fw-bold mb-1">
                            Key note Speaker - Mr. Mizan Abdulrouf (Barrister and Former Secretary General of IAACA)
                          </h6>
                        </div>
                        <div style={{ whiteSpace: "nowrap" }}>7:20 PM – 7:35 PM</div>
                      </div>
                      <div className="schedule-item">
                        <div>
                          <h6 className="fw-bold mb-1">
                            Networking, Drinks & Refreshments
                          </h6>
                        </div>
                        <div style={{ whiteSpace: "nowrap" }}>7:45 PM – 9:00 PM</div>
                      </div>
                    </div>

                    <div className="schedule-date mt-4">Venue</div>
                    <div className="schedule-card p-0">
                      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.8959052802597!2d-0.1480405229158971!3d51.51512571013845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761ad4ca8e31f5%3A0xeff180698a7cd0b1!2s1864%20Rooftop%20Bar%20%26%20Kitchen%2C%20Oxford%20Street!5e0!3m2!1sen!2sin!4v1780294128133!5m2!1sen!2sin" width="400" height="300" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                      <div className="p-4">
                        <h6 className="fw-bold mb-1">
                          1864 Rooftop Bar &amp; Kitchen,
                        </h6>
                        {/* <p className="mb-1 ">1864 Rooftop Bar &amp; Kitchen,</p> */}
                        <p className="mb-0 ">6th Floor,
                          John Lewis,
                          300 Oxford Street,
                          London WC1 1DX</p>
                          <p className="mb-0 ">Private entrance - 4 Old Cavendish St, London W1G 0NE</p>
                      </div>
                    </div>
                  </div>
                  <hr className="d-block d-sm-none" />
                  <div className="col-lg-6 col-md-6 col-12" id="rsvp-form" style={{ scrollMarginTop: "150px", position: "relative" }}>
                    <RSVPForm />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </SummerThemeWrapper>
  );
};

export default SummerMeet;
